// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"8dff8f4c","425":"727166cc","637":"a4c96ce8","640":"8dff8f4c","764":"c3fd195d","829":"6d01fee9"}[chunkId] + ".chunk.css";
};